import { createSelector } from '@reduxjs/toolkit';

import { organizationApi } from './organizationApi';

import type { RootState } from 'store';

/** Every organisation the user manages, or `undefined` before `GET /organization/managed` lands. */
export const selectManagedOrganizations = (state: RootState) =>
  organizationApi.endpoints.getManagedOrganizations.select()(state)?.data?.organizations;

/**
 * The first managed organisation, which is what the console treats as "my organisation" - there is
 * no organisation switcher. Do not use it to answer a question about a SPECIFIC organisation id:
 * it is unfiltered, so for a user managing more than one it can be an unrelated organisation. Match
 * against `selectManagedOrganizations` for that.
 */
export const selectCurrentOrganization = (state: RootState) => selectManagedOrganizations(state)?.[0];

export const selectCurrentOrganizationId = createSelector(
  selectCurrentOrganization,
  (data) => data?.organization?.organizationId
);

// There is deliberately no `selectIsUserCurrentOrganizationAdmin` here. The organisation role is
// authorization, and authorization goes through `useCan('organisation:manage')` - the adapter reads
// `selectManagedOrganizations` and resolves the role by id (HNS-353). Reintroducing a role selector
// would put a second answer to the same question back in the console.
